// Pill/tag background colors grouped by movement pattern
export const MUSCLE_COLORS = {
  chest:     '#E8A87C',
  back:      '#E8A87C',
  shoulders: '#E8A87C',
  biceps:    '#E8A87C',
  triceps:   '#E8A87C',
  legs:      '#7EB8F7',
  core:      '#A78BFA',
  cardio:    '#34D399',
};

// Dark text to overlay on the colored pill backgrounds
export const MUSCLE_TEXT_COLORS = {
  chest:     '#7A3F10',
  back:      '#7A3F10',
  shoulders: '#7A3F10',
  biceps:    '#7A3F10',
  triceps:   '#7A3F10',
  legs:      '#1A4B7A',
  core:      '#3B1FA8',
  cardio:    '#065F46',
};

// Collapsed display labels (chest+back+shoulders+biceps+triceps → "Arms")
export const MUSCLE_GROUP_LABELS = {
  chest:     'Arms',
  back:      'Arms',
  shoulders: 'Arms',
  biceps:    'Arms',
  triceps:   'Arms',
  legs:      'Legs',
  core:      'Core',
  cardio:    'Cardio',
};
